var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-702-957H740V67H-702z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-701-27H741v94H-701z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v70H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 35,
    r: 35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 15h40v40H30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M69.517 36.117C64.433 31.3 57.567 28.333 50 28.333S35.567 31.3 30.483 36.117c-.3.3-.483.716-.483 1.183 0 .467.183.883.483 1.183l4.134 4.134c.3.3.716.483 1.183.483.45 0 .867-.183 1.167-.467A19.027 19.027 0 0141.4 39.55a1.66 1.66 0 00.933-1.5v-5.167c2.417-.8 5-1.216 7.667-1.216s5.25.416 7.667 1.2v5.166c0 .65.383 1.234.933 1.5a19.178 19.178 0 014.433 3.084c.3.3.717.466 1.167.466a1.66 1.66 0 001.183-.483l4.134-4.133c.3-.3.483-.717.483-1.184 0-.45-.183-.866-.483-1.166z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHang);
export default __webpack_public_path__ + "static/media/hang.406ece9f7725592ad5d7dc70c8292d99.svg";
export { ForwardRef as ReactComponent };